import { urlConst } from '../consts';
import { apiService } from './api.service';

export const eventsService = {
    getAll
};

function getAll() {
    return apiService.get(urlConst.API_GET_EVENTS);
}
